/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Compare_Row_Dwg_AcInputs */

const en_cad_compare_row_dwg_ac = /** @type {(inputs: Cad_Compare_Row_Dwg_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Native DWG, full fidelity`)
};

/**
* | output |
* | --- |
* | "Native DWG, full fidelity" |
*
* @param {Cad_Compare_Row_Dwg_AcInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_compare_row_dwg_ac = /** @type {((inputs?: Cad_Compare_Row_Dwg_AcInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Compare_Row_Dwg_AcInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_compare_row_dwg_ac(inputs)
});
export { cad_compare_row_dwg_ac as "cad.compare.row_dwg_ac" }